/**
 * Rich Text Editor classes defined here.
 */
/**
 * @hidden
 * @deprecated
 */
export var CLASS_IMAGE_RIGHT = 'e-imgright';
export var CLASS_IMAGE_LEFT = 'e-imgleft';
export var CLASS_IMAGE_CENTER = 'e-imgcenter';
export var CLASS_IMAGE_BREAK = 'e-imgbreak';
export var CLASS_CAPTION = 'e-img-caption';
export var CLASS_RTE_CAPTION = 'e-rte-img-caption';
export var CLASS_CAPTION_INLINE = 'e-caption-inline';
export var CLASS_IMAGE_INLINE = 'e-imginline';
